import { useState } from "react"
import { observer } from "mobx-react"
import { Flex, Form, Typography } from "antd"

import { authStore, Merchant } from "@src/app/authStore"
import { notify } from "@src/app/components/notify"
import { ConversionAutocomplete } from "@src/pages/settingsAutoConversion/ui/ConversionAutocomplete"
import { ConversionCurrencyList } from "@src/pages/settingsAutoConversion/ui/ConversionCurrencyList"
import { ConversionForm } from "@src/pages/settingsAutoConversion/ui/ConversionForm"
import { catchErrors, merchantApi } from "@src/shared/api"
import { NetworkAll, SymbolAll } from "@src/shared/api/generated"

interface FormValues {
  symbol: any
}
export const SettingsAutoConversionPage = observer(() => {
  const [isEnabled, setIsEnabled] = useState(
    () => Boolean(authStore.merchant?.exchange_to?.symbol) ?? false,
  )

  const [isLoading, setIsLoading] = useState(false)

  const { merchant } = authStore

  const [form] = Form.useForm()

  const getNetwokrValue = (symbol?: SymbolAll) => {
    if (!isEnabled) return null

    if (symbol === "USDT") return NetworkAll.Tron

    return NetworkAll.Fiat
  }

  const onSubmit = async (value: FormValues) => {
    setIsLoading(true)

    merchantApi
      .setExchangeTo({
        // TODO: fix types in api
        // @ts-ignore
        network: getNetwokrValue(value.symbol),
        symbol: value.symbol,
      })
      .then(({ data: { data } = {} }) =>
        authStore
          .reload()
          .then(() =>
            notify.success(
              value === null
                ? "Auto conversion switched off"
                : "Currency has been chosen",
            ),
          ),
      )
      .catch(catchErrors)
      .finally(() => setIsLoading(false))
  }

  return (
    <Flex gap={32} vertical>
      <Typography.Text style={{ fontSize: 16 }}>
        Autoconversion refers to the automatic conversion of all incoming
        cryptocurrencies into the currency of your preference. Choose the
        currency
      </Typography.Text>

      <ConversionForm
        form={form}
        isLoading={isLoading}
        merch={merchant as Merchant}
        submit={(v) => onSubmit(v as FormValues)}
      />

      {/*<ConversionCurrencyList />*/}

      {/*CR46-2716*/}
      {/*<ConversionAutocomplete />*/}
    </Flex>
  )
})
